const SMS_BODY = "Dzień dobry, chciałbym zapytać o możliwość przejazdu.";
const PHONE_NUMBER = "+48737473050";

export const TEL_HREF = `tel:${PHONE_NUMBER}`;

export const getSmsHref = () => {
  const body = encodeURIComponent(SMS_BODY);
  const isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
  return isIOS
    ? `sms:${PHONE_NUMBER}&body=${body}`
    : `sms:${PHONE_NUMBER}?body=${body}`;
};

export const handleSmsClick = (e) => {
  e.preventDefault();
  e.stopPropagation();
  window.location.href = getSmsHref();
};
